import React, { useEffect } from "react";
var ScrollDetector = function ScrollDetector(_ref) {
    var onScrolledToEnd = _ref.onScrolledToEnd, _ref$threshold = _ref.threshold, threshold = _ref$threshold === void 0 ? 200 : _ref$threshold, children = _ref.children;
    useEffect(function () {
        document.addEventListener("scroll", trackScrolling);
        return function () {
            return document.removeEventListener("scroll", trackScrolling);
        };
    });
    var isBottom = function isBottom(element) {
        return element.getBoundingClientRect().bottom - threshold <= window.innerHeight;
    };
    var trackScrolling = function trackScrolling() {
        var wrappedElement = document.getElementById("scroll-wrapper");
        if (isBottom(wrappedElement)) {
            onScrolledToEnd();
            document.removeEventListener("scroll", trackScrolling);
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        id: "scroll-wrapper"
    }, children);
};
export default ScrollDetector;
